import { render, staticRenderFns } from "./ListWorkbookAccessRequested.vue?vue&type=template&id=77790012&lang=pug"
import script from "./ListWorkbookAccessRequested.vue?vue&type=script&lang=js"
export * from "./ListWorkbookAccessRequested.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77790012')) {
      api.createRecord('77790012', component.options)
    } else {
      api.reload('77790012', component.options)
    }
    module.hot.accept("./ListWorkbookAccessRequested.vue?vue&type=template&id=77790012&lang=pug", function () {
      api.rerender('77790012', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ListWorkbookAccessRequested.vue"
export default component.exports